// Matching values from next.config.js
export const deviceSizes = [480, 640, 750, 828, 1080, 1200, 1440, 1920, 2048, 3840];
